/**
 * Cyrenza API Configuration
 * Minimal configuration for unified services architecture
 */

// Base API URL - automatically uses environment variable
// Note: Should NOT include /api/v1 suffix - that's added per endpoint
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_API_URL ||
  'https://api.cyrenza.com';

// API Version
export const API_VERSION = 'v1';

/**
 * Build full URL from endpoint
 * Automatically adds /api/v1 prefix if not present
 */
export const buildUrl = (endpoint: string): string => {
  // If endpoint already starts with /api, use it as-is
  if (endpoint.startsWith('/api/')) {
    return `${API_BASE_URL}${endpoint}`;
  }
  // Otherwise, add /api/v1 prefix
  return `${API_BASE_URL}/api/${API_VERSION}${endpoint}`;
};

/**
 * Unified service endpoint
 */
export const UNIFIED_SERVICE_ENDPOINT = '/service';
